import { render, staticRenderFns } from "./loader-pie.vue?vue&type=template&id=625aca71&"
import script from "./loader-pie.vue?vue&type=script&lang=js&"
export * from "./loader-pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports